module.exports = __webpack_public_path__ + "img/aermod-sample-runs.50696a9e.png";